import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { CONFIG, BRAND } from "@/config";
import Newsletter from "./Newsletter";
import yazaLogo from "@/assets/yaza-logo.png";

export default function Footer() {
  return (
    <footer className="bg-black" data-testid="footer">
      <div className="hazard-stripes h-2" />
      <div className="mx-auto max-w-[1600px] px-5 py-16 md:px-10 md:py-24">
        <div className="grid gap-12 md:grid-cols-2">
          <div>
            <Link to="/" className="inline-flex items-end gap-3">
              <img src={yazaLogo} alt="YAZA" className="h-16 w-auto md:h-24" />
              <span className="font-display text-4xl leading-none text-yaza-accent md:text-6xl">EXOTICS</span>
            </Link>
            <p className="mt-6 max-w-sm text-sm text-yaza-dim">{BRAND.metaDescription}</p>
            <div className="mt-8 flex gap-6 text-xs font-semibold uppercase tracking-[0.2em]">
              <Link to="/" className="hover:text-yaza-accent">Home</Link>
              <Link to="/drops" className="hover:text-yaza-accent">Drops</Link>
              <Link to="/strains" className="hover:text-yaza-accent">Strains</Link>
              <Link to="/tap-in" className="hover:text-yaza-accent">Tap In</Link>
            </div>
            <a
              href={CONFIG.instagramUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-ig-link"
              className="mt-6 inline-flex items-center gap-2 text-sm text-yaza-dim hover:text-yaza-accent"
            >
              <Instagram size={18} /> @{CONFIG.instagramHandle}
            </a>
          </div>

          <div>
            <Newsletter
              source="footer"
              heading="BE THE FIRST"
              subtext="Be the first to get exclusive discounts and updates!"
            />
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-2 border-t border-yaza-border pt-8 text-xs text-neutral-600 md:flex-row md:items-center md:justify-between">
          <p>© 2026 YAZA EXOTICS · A {BRAND.parent} brand</p>
          <p className="max-w-xl md:text-right">
            21+ only. For informational purposes. Nothing on this site is an offer to sell or a solicitation
            where prohibited. Please consume responsibly and comply with local laws.
          </p>
        </div>
      </div>
    </footer>
  );
}
